export default {
  title: 'Promo Code Details',
  back: 'Back to Promo Codes',
  tabs: {
    customers: 'Customers',
    orders: 'Orders',
  },
  metrics: {
    gmv: 'GMV',
    average_order_value: 'Avg. Order Value',
    customer_adoption: 'Unique customers',
  },
  toasts: {
    failed_to_load_stats: 'Failed to load statistics',
  },
};
